export const NAME = 'gains';

export const RECEIVE_ACCOUNT_GAINS = "RECEIVE_ACCOUNT_GAINS";
export const REQUEST_ACCOUNT_GAINS = "REQUEST_ACCOUNT_GAINS";
export const FAILURE_ACCOUNT_GAINS = "FAILURE_ACCOUNT_GAINS";



// WEBPACK FOOTER //
// ./src/services/account/gains/constants.js